const normalizeText = (value = '') => `${value || ''}`.trim().toLowerCase()

export const normalizeGatewayPaymentName = (payment = '') => {
  const normalized = normalizeText(payment)
  if (!normalized) return ''

  if (normalized === 'webpay' || normalized === 'flow') return 'Webpay'
  if (normalized === 'mercadopago' || normalized === 'mercado pago') return 'Mercado Pago'
  if (normalized === 'klap') return 'Klap'

  return `${payment || ''}`.trim()
}

export const getGatewayPaymentKey = (payment = '') => {
  const normalized = normalizeText(payment)
  if (normalized === 'webpay' || normalized === 'flow') return 'flow'
  if (normalized === 'mercadopago' || normalized === 'mercado pago') return 'mercadopago'
  if (normalized === 'klap') return 'klap'
  return ''
}

export const isGatewayPayment = (payment = '') => !!getGatewayPaymentKey(payment)

export const isImmediateGatewayPayment = (payment = '') => {
  const key = getGatewayPaymentKey(payment)
  return key === 'flow' || key === 'mercadopago'
}

export const buildPublicPaymentBridgeUrl = ({
  root = '',
  business = '',
  ticketId = ''
} = {}) => {
  const cleanRoot = `${root || ''}`.trim().replace(/\/+$/, '')
  const base = cleanRoot.endsWith('/w') ? cleanRoot : `${cleanRoot}/w`
  return `${base}/${business}/pago/${ticketId}`
}

export const buildPublicTicketUrl = ({
  business = '',
  ticketId = ''
} = {}) => {
  const cleanBusiness = `${business || ''}`.trim()
  const cleanTicketId = `${ticketId || ''}`.trim()
  return `/${cleanBusiness}/pedido/${cleanTicketId}`
}

export const redirectGatewayPayment = async ({
  http,
  ticket,
  currentUrl = ''
} = {}) => {
  const gateway = getGatewayPaymentKey(ticket && ticket.payment ? ticket.payment : '')
  if (!http || !ticket || !ticket._id || !gateway) return null

  if (gateway === 'flow') {
    const res = await http.post(`${ticket._id}/flow`)
    const data = res && res.data && res.data.data ? res.data.data : {}
    if (data.url) {
      window.location.href = `${data.url}?token=${data.token || ''}`
    }
    return data
  }

  if (gateway === 'klap') {
    const res = await http.post(`${ticket._id}/klap`)
    const data = res && res.data ? res.data : {}
    if (data.redirect_url) {
      window.location.href = data.redirect_url
    }
    return data
  }

  if (gateway === 'mercadopago') {
    const res = await http.post(`${ticket._id}/mercadopago`, {
      url: currentUrl || (typeof window !== 'undefined' ? window.location.href.split('?')[0] : '')
    })
    const data = res && res.data ? res.data : {}
    if (data.init_point) {
      window.location.href = data.init_point
    }
    return data
  }

  return null
}
